export default "__VITE_ASSET__Ctp6hLxV__"